import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userData: null,
  isAuthenticated: false,
  isBanned: false,
  isLoading: false,
  error: null,
  lastFetchTime: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    fetchUserStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },

    fetchUserSuccess: (state, action) => {
      state.isLoading = false;
      state.userData = action.payload;
      state.isAuthenticated = true;
      state.isBanned = action.payload?.isBanned || action.payload?.status === 'banned' || false;
      state.error = null;
      state.lastFetchTime = Date.now();
    },

    fetchUserError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
      state.userData = null;
      state.isBanned = false;
    },

    updateUserData: (state, action) => {
      if (state.userData) {
        state.userData = { ...state.userData, ...action.payload };
        state.isBanned = action.payload?.isBanned || action.payload?.status === 'banned' || state.isBanned;
      }
    },

    clearUserData: (state) => {
      state.userData = null;
      state.isAuthenticated = false;
      state.isBanned = false;
      state.error = null;
      state.lastFetchTime = null;
    },

    setBanStatus: (state, action) => {
      state.isBanned = action.payload;
      if (state.userData) {
        state.userData.isBanned = action.payload;
      }
    },
  },
});

export const {
  fetchUserStart,
  fetchUserSuccess,
  fetchUserError,
  updateUserData,
  clearUserData,
  setBanStatus,
} = userSlice.actions;

export const selectUser = (state) => state.user.userData;
export const selectIsAuthenticated = (state) => state.user.isAuthenticated;
export const selectIsBanned = (state) => state.user.userData?.is_ban;
export const selectUserLoading = (state) => state.user.isLoading;
export const selectUserError = (state) => state.user.error;
export const selectLastFetchTime = (state) => state.user.lastFetchTime;



export const selectIsValidUser = (state) => 
  state.user.isAuthenticated && !state.user.isBanned && state.user.userData;

export default userSlice.reducer;